import {
  // Admin constants
  ADMIN_USERS_REQUEST,
  ADMIN_USERS_SUCCESS,
  ADMIN_USERS_FAIL,
  //
  ADMIN_USER_DETAILS_REQUEST,
  ADMIN_USER_DETAILS_SUCCESS,
  ADMIN_USER_DETAILS_FAIL,
  //
  ADMIN_UPDATE_USER_REQUEST,
  ADMIN_UPDATE_USER_SUCCESS,
  // ADMIN_UPDATE_USER_RESET,
  ADMIN_UPDATE_USER_FAIL,
  //
  ADMIN_DELETE_USER_REQUEST,
  ADMIN_DELETE_USER_SUCCESS,
  // ADMIN_DELETE_USER_RESET,
  ADMIN_DELETE_USER_FAIL,
  //================= =================//
  //
  PRE_SIGNUP_REQUEST,
  PRE_SIGNUP_SUCCESS,
  PRE_SIGNUP_FAIL,
  //
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_FAIL,
  //
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_SUCCESS_GOOGLE,
  LOGIN_FAIL,
  //
  LOAD_USER_REQUEST,
  LOAD_USER_SUCCESS,
  LOAD_USER_FAIL,
  //
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
  //
  EDIT_USER_REQUEST,
  EDIT_USER_SUCCESS,
  EDIT_USER_FAIL,
  //
  DEACTIVATE_USER_ACCOUNT_REQUEST,
  DEACTIVATE_USER_ACCOUNT_SUCCESS,
  DEACTIVATE_USER_ACCOUNT_FAIL,
  //
  DELETE_USER_ACCOUNT_REQUEST,
  DELETE_USER_ACCOUNT_SUCCESS,
  DELETE_USER_ACCOUNT_FAIL,
  //
  CHANGE_USER_PASSWORD_REQUEST,
  CHANGE_USER_PASSWORD_SUCCESS,
  CHANGE_USER_PASSWORD_FAIL,
  //
  FORGOT_USER_PASSWORD_REQUEST,
  FORGOT_USER_PASSWORD_SUCCESS,
  FORGOT_USER_PASSWORD_FAIL,
  //
  RESET_USER_PASSWORD_REQUEST,
  RESET_USER_PASSWORD_SUCCESS,
  RESET_USER_PASSWORD_FAIL,
  CLEAR_ERRORS,
} from "../../constants/userConstants";
import apiClient from "../../lib/apiClient";

export const adminLogin = (email, password) => async (dispatch) => {
  try {
    dispatch({
      type: LOGIN_REQUEST,
    });
    const config = {
      withCredentials: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    const { data } = await apiClient.post(
      "/admin/auth",
      { email, password },
      config
    );

    dispatch({ type: LOGIN_SUCCESS, payload: data.user });

    // save user id in local storage
    window.localStorage.setItem("userId", JSON.stringify(data.user._id));
  } catch (error) {
    dispatch({
      type: LOGIN_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

export const login = (email, password) => async (dispatch) => {
  try {
    dispatch({
      type: LOGIN_REQUEST,
    });
    const config = {
      withCredentials: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    const { data } = await apiClient.post(
      "/auth",
      { email, password },
      config
    );

    dispatch({ type: LOGIN_SUCCESS, payload: data.user });

    // save user id in local storage
    window.localStorage.setItem("userId", JSON.stringify(data.user._id));
  } catch (error) {
    dispatch({
      type: LOGIN_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

export const loginGoogle = (user) => async (dispatch) => {
  try {
    dispatch({
      type: LOGIN_REQUEST,
    });
    const config = {
      withCredentials: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    const { data } = await apiClient.post(
      "/google-login",
      { user },
      config
    );

    dispatch({ type: LOGIN_SUCCESS_GOOGLE, payload: data });

    // save user id in local storage
    window.localStorage.setItem("userId", JSON.stringify(data.user._id));
  } catch (error) {
    dispatch({
      type: LOGIN_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Pre signup
export const preSignup = (userData) => async (dispatch) => {
  try {
    dispatch({
      type: PRE_SIGNUP_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.post(
      "/pre-signup",
      userData,
      config
    );
    dispatch({ type: PRE_SIGNUP_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: PRE_SIGNUP_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Resend activation email — the backend re-uses the existing pending-signup
// token. The frontend no longer needs to keep the original signup credentials.
export const resendActivation = (token) => async (dispatch) => {
  try {
    dispatch({ type: PRE_SIGNUP_REQUEST });
    const { data } = await apiClient.post(
      "/resend-activation",
      { token },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: PRE_SIGNUP_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: PRE_SIGNUP_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Signup user
export const signup = (userData) => async (dispatch) => {
  try {
    dispatch({
      type: SIGNUP_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.post(
      "/signup",
      userData,
      config
    );
    dispatch({ type: SIGNUP_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: SIGNUP_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Load user from local storage
export const loadUserLocalStorage = () => async (dispatch) => {
  const message = "Please login";
  const user = JSON.parse(window.localStorage.getItem("user"));
  if (user) {
    try {
      dispatch({
        type: LOAD_USER_REQUEST,
      });

      dispatch({
        type: LOAD_USER_SUCCESS,
        payload: user,
      });
    } catch (error) {
      dispatch({
        type: LOAD_USER_FAIL,
        payload: message,
      });
    }
  }
};

// Load user from backend
export const loadUser = () => async (dispatch) => {
  try {
    dispatch({
      type: LOAD_USER_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };

    const { data } = await apiClient.get(
      // `/${username}`
      "/me",
      config
    );
    dispatch({ type: LOAD_USER_SUCCESS, payload: data.user });

    // window.localStorage.setItem("user", JSON.stringify(data.user));
  } catch (error) {
    dispatch({
      type: LOAD_USER_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Logout admin
export const logoutAdmin = (adminOut) => async (dispatch) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };

    await apiClient.post("/logout", {}, config);

    if (window.localStorage.getItem("user") !== null) {
      window.localStorage.removeItem("user");
    }
    if (window.localStorage.getItem("userId") !== null) {
      window.localStorage.removeItem("userId");
    }

    dispatch({ type: LOGOUT_SUCCESS, payload: adminOut && adminOut });
    // if(adminOut) {
    // } else {
    //   dispatch({ type: LOGOUT_SUCCESS})
    // }
  } catch (error) {
    dispatch({
      type: LOGOUT_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Logout user
export const logoutUser = () => async (dispatch) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };

    await apiClient.post("/logout", {}, config);

    if (window.localStorage.getItem("user") !== null) {
      window.localStorage.removeItem("user");
    }
    if (window.localStorage.getItem("userId") !== null) {
      window.localStorage.removeItem("userId");
    }

    dispatch({ type: LOGOUT_SUCCESS });
  } catch (error) {
    dispatch({
      type: LOGOUT_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Edit user profile
export const editUserProfile = (userData) => async (dispatch) => {
  try {
    dispatch({
      type: EDIT_USER_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.put(
      "/update/profile",
      userData,
      config
    );
    dispatch({ type: EDIT_USER_SUCCESS, payload: data.success });
  } catch (error) {
    dispatch({
      type: EDIT_USER_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// deactivate user account
export const deactivateUserAccount = (password) => async (dispatch) => {
  try {
    dispatch({
      type: DEACTIVATE_USER_ACCOUNT_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.put(
      "/deactivate/me",
      { password },
      config
    );
    if (window.localStorage.getItem("user") !== null) {
      window.localStorage.removeItem("user");
    }
    if (window.localStorage.getItem("userId") !== null) {
      window.localStorage.removeItem("userId");
    }
    dispatch({ type: DEACTIVATE_USER_ACCOUNT_SUCCESS, payload: data.success });
    dispatch({ type: LOGOUT_SUCCESS });
  } catch (error) {
    dispatch({
      type: DEACTIVATE_USER_ACCOUNT_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// delete user account
export const deleteUserAccount = (password) => async (dispatch) => {
  try {
    dispatch({
      type: DELETE_USER_ACCOUNT_REQUEST,
    });
    // For apiClient.delete, body goes in `data`, not as a separate arg.
    const { data } = await apiClient.delete(
      "/delete/me",
      {
        data: { password },
        withCredentials: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    if (window.localStorage.getItem("user") !== null) {
      window.localStorage.removeItem("user");
    }
    if (window.localStorage.getItem("userId") !== null) {
      window.localStorage.removeItem("userId");
    }
    dispatch({ type: DELETE_USER_ACCOUNT_SUCCESS, payload: data.success });
    dispatch({ type: LOGOUT_SUCCESS });
  } catch (error) {
    dispatch({
      type: DELETE_USER_ACCOUNT_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Change user password
export const changeUserPassword = (passwords) => async (dispatch) => {
  try {
    dispatch({
      type: CHANGE_USER_PASSWORD_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.put(
      "/settings/password",
      passwords,
      config
    );
    dispatch({ type: CHANGE_USER_PASSWORD_SUCCESS, payload: data.success });
  } catch (error) {
    dispatch({
      type: CHANGE_USER_PASSWORD_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Forgot user password
export const forgotUserPassword = (email) => async (dispatch) => {
  try {
    dispatch({
      type: FORGOT_USER_PASSWORD_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    const { data } = await apiClient.post(
      "/forgot-password",
      email,
      config
    );
    dispatch({ type: FORGOT_USER_PASSWORD_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: FORGOT_USER_PASSWORD_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Reset user password
export const resetUserPassword = (passwords) => async (dispatch) => {
  try {
    dispatch({
      type: RESET_USER_PASSWORD_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    const { data } = await apiClient.put(
      "/reset-password",
      passwords,
      config
    );
    dispatch({ type: RESET_USER_PASSWORD_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: RESET_USER_PASSWORD_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// ============================== Admin actions ============================== //
export const getUsersAdmin = () => async (dispatch) => {
  try {
    dispatch({
      type: ADMIN_USERS_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.get(
      "/admin/users",
      config
    );
    dispatch({ type: ADMIN_USERS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: ADMIN_USERS_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Get user details admin
export const getUserDetailsAdmin = (id) => async (dispatch) => {
  try {
    dispatch({
      type: ADMIN_USER_DETAILS_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.get(
      `/admin/user/${id}`,
      config
    );
    dispatch({ type: ADMIN_USER_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: ADMIN_USER_DETAILS_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Update user admin
export const updateUserAdmin = (id, userData) => async (dispatch) => {
  try {
    dispatch({
      type: ADMIN_UPDATE_USER_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.put(
      `/admin/update/user/${id}`,
      userData,
      config
    );
    dispatch({ type: ADMIN_UPDATE_USER_SUCCESS, payload: data.success });
  } catch (error) {
    dispatch({
      type: ADMIN_UPDATE_USER_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Delete user admin
export const deleteUserAdmin = (id) => async (dispatch) => {
  try {
    dispatch({
      type: ADMIN_DELETE_USER_REQUEST,
    });
    const config = {
      withCredentials: true,
    };
    const { data } = await apiClient.delete(
      `/admin/delete/user/${id}`,
      config
    );
    dispatch({ type: ADMIN_DELETE_USER_SUCCESS, payload: data.success });
  } catch (error) {
    dispatch({
      type: ADMIN_DELETE_USER_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

/// Forgot admin password (step 1: request reset code)
export const forgotPasswordAdmin = (email) => async (dispatch) => {
  try {
    dispatch({
      type: FORGOT_USER_PASSWORD_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    const { data } = await apiClient.post(
      "/admin-forgot-password",
      email,
      config
    );
    dispatch({ type: FORGOT_USER_PASSWORD_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: FORGOT_USER_PASSWORD_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Reset admin password (step 2: submit code + new password)
export const resetPasswordAdmin = (payload) => async (dispatch) => {
  try {
    dispatch({ type: RESET_USER_PASSWORD_REQUEST });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    const { data } = await apiClient.put(
      "/admin-reset-password",
      payload,
      config
    );
    dispatch({ type: RESET_USER_PASSWORD_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: RESET_USER_PASSWORD_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

export const editAdminProfile = (userData) => async (dispatch) => {
  try {
    dispatch({
      type: EDIT_USER_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.put(
      "/update/admin/profile",
      userData,
      config
    );
    dispatch({ type: EDIT_USER_SUCCESS, payload: data.success });
  } catch (error) {
    dispatch({
      type: EDIT_USER_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};
///

// Clear errors
export const clearErrors = () => async (dispatch) => {
  dispatch({
    type: CLEAR_ERRORS,
  });
};
